var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { doKey2ClickUp } from "survey-core";
import { TitleActions } from "./title-actions";
import { SvgIcon } from "../svg-icon/svg-icon";
var TitleElement = /** @class */ (function (_super) {
    __extends(TitleElement, _super);
    function TitleElement(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(TitleElement.prototype, "element", {
        get: function () {
            return this.props.element;
        },
        enumerable: false,
        configurable: true
    });
    TitleElement.prototype.renderTitleExpandableSvg = function () {
        if (!this.element.getCssTitleExpandableSvg())
            return null;
        var iconName = this.element.isExpanded ? "icon-collapse-16x16" : "icon-expand-16x16";
        return React.createElement(SvgIcon, { className: this.element.getCssTitleExpandableSvg(), iconName: iconName, size: "auto" });
    };
    TitleElement.prototype.render = function () {
        var element = this.element;
        if (!element || !element.hasTitle)
            return null;
        var ariaLabel = element.titleAriaLabel || undefined;
        var titleExpandableSvg = this.renderTitleExpandableSvg();
        var titleContent = (React.createElement(TitleActions, { element: element, cssClasses: element.cssClasses, renderActions: this.props.renderActions }));
        var onClick = undefined;
        var onKeyUp = undefined;
        if (element.hasTitleEvents) {
            onKeyUp = function (evt) {
                doKey2ClickUp(evt.nativeEvent);
            };
        }
        var CustomTag = element.titleTagName;
        return (React.createElement(CustomTag, { className: element.cssTitle, id: element.ariaTitleId, "aria-label": ariaLabel, tabIndex: element.titleTabIndex, "aria-expanded": element.titleAriaExpanded, role: element.titleAriaRole, onClick: onClick, onKeyUp: onKeyUp },
            titleExpandableSvg,
            titleContent));
    };
    return TitleElement;
}(React.Component));
export { TitleElement };
